import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

const CreateFaqEntryModal = ({ open, handleClose, handleSubmit, categories }) => {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    categoryId: ""
  });

  const initialFormData = {
    title: "",
    description: "",
    categoryId: ""
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit(formData);
    setFormData(initialFormData);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} >
      <DialogContent>
        <form onSubmit={onSubmit}>
          <Typography variant="h3">Create FAQ Entry</Typography>
          <div>
            <TextField
              id="title"
              label="Title"
              name="title"
              variant="outlined"
              type="text"
              fullWidth
              value={formData.title}
              onChange={(e) => handleChange(e)}
            />
          </div>
          <div>
            <TextField
              id="description"
              label="Description"
              name="description"
              variant="outlined"
              type="text"
              fullWidth
              value={formData.description}
              onChange={(e) => handleChange(e)}
            />
          </div>
          <div>
            <FormControl fullWidth>
              <InputLabel id="select-category-label">Category</InputLabel>
              <Select
                labelId="select-category-label"
                id="categoryId"
                name="categoryId"
                value={formData.categoryId}
                label="Category"
                onChange={handleChange}
              >
                {categories.map((category) => (
                  <MenuItem key={category.id} value={category.id}>
                    {category.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button type="submit" onClick={onSubmit}>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateFaqEntryModal;
